import React from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Lead from '../../components/Lead/Lead';
import Instruction from '../../components/Instruction/Instruction';
import { goToFirstStep } from '../../store/step/actions';

const HomePage = props => (
  <div className="Home">
    <Lead isHomePage goToFirstStep={props.goToFirstStep} />
    <Instruction />
  </div>
);

HomePage.propTypes = {
  goToFirstStep: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({

});

export default connect(
  mapStateToProps,
  dispatch => bindActionCreators({
    goToFirstStep,
  }, dispatch),
)(HomePage);

